import { db, getAllByIds } from '@/utils/Firebase'

export const WEEK_NAMES_COLLECTION = 'weekNames'

export const WEEK_NAME_MAX = 24

export const weekNameScopeKey = (scope) => {
    if (!scope) return null
    if (scope.collection === 'assignedRoutines') return scope.studentId ? `s_${scope.studentId}` : null
    if (!scope.groupId && scope.groupId !== 0) return null
    return `g_${scope.teamId || 'none'}_${scope.groupId}`
}

export const weekNameDocId = (scope, weekStart) => {
    const key = weekNameScopeKey(scope)
    return key && weekStart ? `${key}_${weekStart}` : null
}

export const loadWeekNames = async (scope, weekStarts = []) => {
    const ids = weekStarts.map(weekStart => weekNameDocId(scope, weekStart))
    const docs = await getAllByIds(WEEK_NAMES_COLLECTION, ids)
    const byId = new Map(docs.map(doc => [doc.objectID, doc.name || '']))
    return Object.fromEntries(weekStarts.map((weekStart, i) => [weekStart, byId.get(ids[i]) || '']))
}

export const saveWeekName = async (scope, weekStart, name, coachId) => {
    const id = weekNameDocId(scope, weekStart)
    if (!id) return
    const ref = db.collection(WEEK_NAMES_COLLECTION).doc(id)
    const value = String(name || '').trim().toUpperCase().slice(0, WEEK_NAME_MAX)
    if (!value) return ref.delete()
    await ref.set({
        name: value,
        weekStart,
        coachId: coachId || null,
        studentId: scope.studentId || null,
        groupId: scope.groupId ?? null,
        teamId: scope.teamId || null,
    })
}
